import React, { FC, useState } from "react";
import { Container } from "../../../../components";
import { Icon, Link, Text } from "@telia/teddy";
import _get from "lodash/get";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { Input } from "../../../../forms/index";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { RapidForm } from "../../../../rapidform/index";
import { getFormById } from "../../../state/selectors/formSelectors";
import * as VERIFICATION_SELECTORS from "../../../state/selectors/verificationSelectors";
import "./DsfMismatchForm.less";

interface StateProps {
    form: Form;
    bankIdDetails?: { firstName?: string; lastName?: string };
}

interface DsfMismatchFormProps extends StateProps {
    setShowLogoutBankIdModal?: (show: boolean) => void;
    update: (bankIDFirstName: string, bankIDLastName: string) => Promise<void>;
}

const DsfMismatchForm: FC<DsfMismatchFormProps> = ({ update, form, setShowLogoutBankIdModal, bankIdDetails }) => {
    const { bankIDFirstName, bankIDLastName } = form.values;
    const [displayError, setDisplayError] = useState(false);

    return (
        <Container className="beta-checkout__section" size="small" whiteBg data-cy="dsf-mismatch">
            {setShowLogoutBankIdModal && (
                <div className="dsf-mismatch__bankid-btn-container">
                    <button className="dsf-mismatch__bankid-btn" onClick={() => setShowLogoutBankIdModal(true)}>
                        Logg ut
                        <Icon className="dsf-mismatch__bankid-icon" name="logout" />
                    </button>
                </div>
            )}
            <div className="dsf-mismatch">
                <div className="dsf-mismatch__flex-container">
                    <Icon name="error" className="dsf-mismatch__warning-icon" />
                    <Text mb="100">
                        Navn og fødselsdato vi hentet fra BankID samsvarer ikke med noen personer i Folkeregisteret.
                        Mest sannsynlig skyldes dette at din bank ikke har lagt inn ditt navn på riktig måte i sine
                        systemer. Kan du skrive
                        <strong className="dsf-mismatch__bold"> det folkeregistrerte navnet</strong> slik du vet det
                        skal være i feltene under under - så sjekker vi mot Folkeregisteret en gang til?
                    </Text>
                </div>
                {bankIdDetails?.firstName && (
                    <div>
                        <div className="dsf-mismatch__fetched-name-label">Navnet vi hentet: </div>
                        <div className="dsf-mismatch__fetched-name">
                            {bankIdDetails?.firstName} {bankIdDetails?.lastName}
                        </div>
                    </div>
                )}
                <RapidForm
                    id={FORM_ID.DSF_MISMATCH}
                    action={"#"}
                    errors={form.errors}
                    values={form.values}
                    visible={form.visible}
                    started={form.started}
                    onSubmit={async () => {
                        setDisplayError(false);
                        const response = await update(bankIDFirstName, bankIDLastName);
                        if (_get(response, "value.isDsfMismatch")) {
                            setDisplayError(true);
                        }
                    }}
                >
                    <Input
                        name={VALIDATION_FIELD.BANK_ID_FIRST_NAME}
                        type="text"
                        label="Fornavn"
                        disabled={false}
                        data-di-mask
                    />
                    <Input
                        name={VALIDATION_FIELD.BANK_ID_LAST_NAME}
                        type="text"
                        label="Etternavn"
                        disabled={false}
                        data-di-mask
                    />
                </RapidForm>
                {displayError && (
                    <div className="dsf-mismatch__error">
                        <div className="dsf-mismatch__flex-container">
                            <Icon name="error-filled" className="dsf-mismatch__error-icon" />
                            <Text mb="100">
                                Her gikk noe galt. Vennligst dobbeltsjekk at feltene er riktige. Vanlige feil er:
                                <ul>
                                    <li>
                                        Navn som inneholder spesialtegn er skrevet uten spesialtegn (for eksempel é
                                        eller ó).
                                    </li>
                                    <li>Etternavnet er feil.</li>
                                    <li>Navnet er forkortet.</li>
                                </ul>
                                Om du fortsatt har problemer, kan du finne ditt folkeregistrerte navn ved å logge inn på{" "}
                                <Link
                                    href="https://www.skatteetaten.no/skjema/opplysninger-i-folkeregisteret/"
                                    variant="text"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Skatteetaten
                                </Link>
                            </Text>
                        </div>
                    </div>
                )}
            </div>
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    form: getFormById(state, FORM_ID.DSF_MISMATCH),
    bankIdDetails: VERIFICATION_SELECTORS.getBankIdDetails(state),
});

export default connect(mapStateToProps)(DsfMismatchForm);
